// Temporary Promotions

export const temporaryPromotionConfig = {
  bannerPCImage: "https://www.codere.es/resources/img/aero_pc.jpg",
  bannerMobileImage: "https://www.codere.es/resources/img/aero_movil.jpg",
  openPromotionButtonText: "Abrir promoción",
  temporaryPromotionSiteUrl: "https://m.codere.mx/csbgonline/iframeAeroFootbal/?source=261920001&country=MX",
  promosInfoPageUrl: "https://www.codere.mx/PromosMX/actives/AEROFUTBOLMX.aspx?authenticated=true",
};
